import { ChatbotImageContainerContainer } from '@/components/kakao/ChatbotImageContainer/ChatbotImageContainer.styles';
import WaitingServiceImg from '@/assets/images/waiting/intro_header.png';
import { useSolution } from '@/stores/common/useSolution';
import { TM_POST_CHANNEL } from '@/constants';

const IntroHeader = () => {
  const { isSolutionFrame } = useSolution();

  function submit() {
    if (isSolutionFrame) window.parent.postMessage({ type: TM_POST_CHANNEL, data: 'Submit:waiting' }, '*');
    else document.querySelector('#form').scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <ChatbotImageContainerContainer className="waiting-intro-header kt-head-img-wrapper">
      <section className="left-area">
        <h4 className="title">예약과 대기를 하나로</h4>
        <h1 className="description">
          카카오와 함께 <br />
          만든 대기서비스
        </h1>
        <div className="bottom-move-button" onClick={submit}>
          <span>솔루션 체험하기</span>
          <img src="/kakao/img/animation_arrow.gif" className="arrow-icon" />
        </div>
      </section>
      <section className="right-area kt-image-wrapper">
        <img className="image" src={WaitingServiceImg} alt="대기 솔루션 소개 이미지" />
      </section>
    </ChatbotImageContainerContainer>
  );
};

export default IntroHeader;
